import { StatusDropdown } from '@/components/ui/status-dropdown';
import { useTranslation } from '@hooks/useTranslation';
import {
  SELECTABLE_USER_STATUSES,
  createUserStatusDropdownConfig,
} from './user-status-config';
import type { User } from '@api/users';

interface UserStatusDropdownProps {
  user: User;
  /** users.write — false renders the control disabled, not absent. */
  canWrite: boolean;
  /** The page confirms and saves. */
  onStatusChange: (user: User, next: User['status']) => void;
}

export function UserStatusDropdown({ user, canWrite, onStatusChange }: UserStatusDropdownProps) {
  const { t } = useTranslation();

  const config = createUserStatusDropdownConfig({
    verified: t('tabs.verified'),
    unverified: t('tabs.unverified'),
    closed: t('tabs.closed'),
  });

  return (
    <StatusDropdown
      value={user.status}
      config={config}
      selectable={SELECTABLE_USER_STATUSES}
      disabled={!canWrite}
      onChange={(next) => {
        if (next === user.status) return;
        onStatusChange(user, next);
      }}
      className="shrink-0"
    />
  );
}
